// import React from 'react';
// import css from './CustomRadioButtons.module.css';
// import classNames from 'classnames';
// import { IoIosRadioButtonOff } from 'react-icons/io';
// import { IoIosRadioButtonOn } from 'react-icons/io';

// const CustomRadioButtons = props => {
//   const {
//     userTypeConfig = [],
//     changeForm,
//     formValues,
//     name,
//     isPackage = false,
//     showExtra = false,
//   } = props;
//   if (userTypeConfig?.length == 0) return null;
//   const typeButtons = userTypeConfig.map(item => {
//     const classes =
//       formValues[name] === item.key
//         ? classNames(css.typeButtonActive, isPackage ? css.typePackage : css.typeButton)
//         : isPackage
//         ? css.typePackage
//         : css.typeButton;
//     return (
//       <p className={classes} key={item.key} onClick={() => changeForm(item.key)}>
//         {formValues[name] === item.key ? (
//           <IoIosRadioButtonOn className={css.onClass} />
//         ) : (
//           <IoIosRadioButtonOff className={css.offClass} />
//         )}
//         {isPackage ? item?.label : item?.sLabel || item?.label
//         // convertLabelToSingular(item.label)
//         }
//       </p>
//     );
//   });
//   return userTypeConfig ? (
//     <div className={isPackage ? css.packageInformation : css.userTypeButtons}>
//       {showExtra ? (
//         <p className={css.disabledLabel}>
//           <p className={css.text}>Box Size</p>
//           <p className={css.text}>L x W x H</p>
//         </p>
//       ) : null}
//       {typeButtons}
//     </div>
//   ) : null;
// };

// export default CustomRadioButtons;
import React from 'react';
import { Field } from 'react-final-form';
import css from './CustomRadioButtons.module.css';
import classNames from 'classnames';
import { IoIosRadioButtonOff, IoIosRadioButtonOn } from 'react-icons/io';

const CustomRadioButtons = ({
  userTypeConfig = [],
  name,
  isPackage = false,
  showExtra = false,
  changeForm,
}) => {
  if (userTypeConfig.length === 0) return null;

  return (
    <Field name={name}>
      {({ input }) => {
        const typeButtons = userTypeConfig.map(item => {
          const classes =
            input.value === item.key
              ? classNames(css.typeButtonActive, isPackage ? css.typePackage : css.typeButton)
              : isPackage
              ? css.typePackage
              : css.typeButton;

          return (
            <p
              className={classes}
              key={item.key}
              onClick={() => {
                input.onChange(item.key), changeForm();
              }}
            >
              {input.value === item.key ? (
                <IoIosRadioButtonOn className={css.onClass} />
              ) : (
                <IoIosRadioButtonOff className={css.offClass} />
              )}
              {isPackage ? item.label : item.sLabel || item.label}
            </p>
          );
        });

        return (
          <div className={isPackage ? css.packageInformation : css.userTypeButtons}>
            {showExtra && (
              <p className={css.disabledLabel}>
                <span className={css.text}>Box Size</span>
                <span className={css.text}>L x W x H</span>
              </p>
            )}
            {typeButtons}
          </div>
        );
      }}
    </Field>
  );
};

export default CustomRadioButtons;
